export const DEFAULT_ZONE_OFFSET = '+00:00'

export const TIMEZONE_OPTIONS = [
  { offset: '+00:00', zone: 'UTC' },
  { offset: '+01:00', zone: 'Central European' },
  { offset: '+02:00', zone: 'Eastern European' },
  { offset: '+03:00', zone: 'Moscow' },
  { offset: '+04:00', zone: 'Dubai' },
  { offset: '+05:00', zone: 'Pakistan' },
  { offset: '+05:30', zone: 'India' },
  { offset: '+06:00', zone: 'Bangladesh' },
  { offset: '+07:00', zone: 'Bangkok' },
  { offset: '+08:00', zone: 'Singapore' },
  { offset: '+09:00', zone: 'Tokyo' },
  { offset: '+10:00', zone: 'Sydney' },
  { offset: '+11:00', zone: 'Solomon Islands' },
  { offset: '+12:00', zone: 'New Zealand' },
  { offset: '-01:00', zone: 'Azores' },
  { offset: '-02:00', zone: 'Mid-Atlantic' },
  { offset: '-03:00', zone: 'Buenos Aires' },
  { offset: '-04:00', zone: 'Atlantic Time' },
  { offset: '-05:00', zone: 'Eastern Time' },
  { offset: '-06:00', zone: 'Central Time' },
  { offset: '-07:00', zone: 'Mountain Time' },
  { offset: '-08:00', zone: 'Pacific Time' },
  { offset: '-09:00', zone: 'Alaska' },
  { offset: '-10:00', zone: 'Hawaii' },
  { offset: '-11:00', zone: 'American Samoa' },
  { offset: '-12:00', zone: 'Baker Island' },
]
